export const COOKIE_ACCEPTED = 'accepted';
export const COOKIE_DENIED = 'denied';

export const MARKETING_CONSENT = 'marketing_consent';
export const PERSONALIZATION_CONSENT = 'personalization_consent';
export const STATISTICS_CONSENT = 'cookie_consent';
